import { Component } from 'react';

import { Logger } from '../../../../models/logger';
import { WidgetTypes } from '../../../../types/dropdown.type';
import { untilDestroyed } from '../../../../utils/until-destroyed';
import { ConvertOptionsContext } from '../../convert-options-context';
import styles from '../html-widget.component.module.scss';


interface WidgetNotesProps {
    formItem: any;
    convertOptionsContext: ConvertOptionsContext;
}

export class WidgetNotesComponent extends Component<WidgetNotesProps> {
    logger = Logger.getLogger('WidgetNotesComponent');

    constructor(props: WidgetNotesProps) {
        super(props);
        props.convertOptionsContext.onSelectedOptionsChanged.pipe(untilDestroyed(this)).subscribe({
            next: () => {
                this.forceUpdate();
            }
        })
    }

    componentDidCatch(err, errorInfo) {
        this.logger.error({
            message: 'Failed to render WidgetNotesComponent',
            data: errorInfo,
            error: err,
        });
    }

    hasNotes(props: WidgetNotesProps) {
        const formChild = props.formItem;
        return formChild.note && formChild.note.text && formChild.note.text.length > 0
    }

    isSupportedFormItem(props: WidgetNotesProps) {
        const formChild = props.formItem;
        return formChild.displayAs === WidgetTypes.SEEKBAR || formChild.displayAs === WidgetTypes.DROPDOWN
    }

    render() {
        const formChild = this.props.formItem;
        if (this.isSupportedFormItem(this.props) && this.hasNotes(this.props)) {
            return <span className={`mt-4 ${styles['not-child-form']} ${styles.description} ${formChild.note.bsTextClass}`}
                dangerouslySetInnerHTML={
                    { __html: formChild.note.textFormatter ? formChild.note.textFormatter(formChild.note.text, { selectedValue: formChild.options.value }) : formChild.note.text }
                }>
            </span>
        } else {
            return <span></span>
        }
    }
}